/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuth } from 'react-oidc-context';
import { useEffect } from 'react';
import { navigateToUrl } from 'single-spa';
import { setSession } from '@/shared/infrastructure/adapters/storage';
import { getLogger } from '@/shared/infrastructure/datadog';
import { partner } from '@/shared/infrastructure/clients/partner';
import { AxiosError } from 'axios';

const appUrl = process.env.APP_URL;
const btgMainBranchId = process.env.REACT_APP_BTG_MAIN_BRANCH_ID;
const btgBranchDefaultName = process.env.REACT_APP_BTG_BRANCH_DEFAULT_NAME;

const RedirectCallBack = (props: any) => {
  const auth = useAuth();

  const isAccountCreated = async () => {
    try {
      await partner().getCurrentAccount();
    } catch (error) {
      if ((error as AxiosError).response?.status === 404) {
        return false;
      }

      throw error;
    }

    return true;
  };

  const isBranchCreated = async () => {
    const branchIdentifier = btgMainBranchId;
    try {
      await partner().getBranchByExternalId(branchIdentifier);
    } catch (error) {
      if ((error as AxiosError).response?.status === 404) {
        return false;
      }

      throw error;
    }

    return true;
  };

  const createAgentBranch = async () => {
    const name = auth.user?.profile.name;
    const email = auth.user?.profile.email;
    const branchIdentifier = btgMainBranchId;

    const {
      data: { platformId },
    } = await partner().getBranchByExternalId(branchIdentifier);

    await partner().createBtgAgent(platformId, {
      name,
      email,
    });
  };

  const createBranch = async () => {
    const unitNameBranch = btgBranchDefaultName;
    const branchIdentifier = btgMainBranchId;

    await partner().createBtgBranchByExternalId({
      unitName: unitNameBranch,
      externalId: branchIdentifier,
    });
  };

  const handleRedirectCallback = async () => {
    try {
      const user = auth.user;

      const userToken = {
        accessToken: user.access_token,
        tokenType: user.token_type,
        refreshToken: user.refresh_token,
        expiresIn: user.expires_in,
      };

      setSession(userToken);

      const branchExists = await isBranchCreated();
      if (!branchExists) {
        await createBranch();
      }

      const accountExists = await isAccountCreated();
      if (!accountExists) {
        await createAgentBranch();
      }

      const redirectUrl = (user.state as string) || appUrl;
      navigateToUrl(redirectUrl);
    } catch (error) {
      getLogger().error(error);
      navigateToUrl(appUrl);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (auth.isAuthenticated) {
      handleRedirectCallback();
    }
  }, [auth.isAuthenticated]);

  return <></>;
};

export default RedirectCallBack;
